<span [ngClass]="{'restrictionText': isRestricted}" class="cellPadding">{{cellValue}}</span>
<sac-tooltip *ngIf="showToolTip" [position]="position" [message]="toolTipError">
    <span class="sac-tooltip-icon"></span>
</sac-tooltip>